import { router } from 'expo-router';
import { StyleSheet, View } from 'react-native';
import { Divider } from 'react-native-paper';

import { NonProfitOrgProfileResponse } from '@/api/models/nonProfitOrgModels';
import EditButton from '@/components/buttons/EditButton';
import InfoButton from '@/components/buttons/InfoButton';
import Text from '@/components/Text';
import { useColor } from '@/hooks/useColor';
import { formatCurrency } from '@/utils/currencyFormat';
import { i18n } from '@/utils/i18n';

const TotalSalariesItem = ({
  canEdit,
  nonProfitOrg
}: {
  canEdit: boolean;
  nonProfitOrg: NonProfitOrgProfileResponse;
}) => {
  const colors = useColor();
  return (
    <View>
      <View style={styles.titleContainer}>
        <View style={styles.titleContent}>
          <Text style={[styles.titleText, { color: colors.titleText }]} fontWeight="700">
            {i18n.t('npo_details.insights.totalSalaries')}
          </Text>
          {/* // TODO: update tooltip title  */}
          <InfoButton title={i18n.t('npo_details.insights.totalSalaries')} />
        </View>
        {canEdit && (
          <EditButton
            onPress={() =>
              router.navigate({
                pathname: '/edit/npoTotalSalaries',
                params: {
                  npoJson: JSON.stringify(nonProfitOrg)
                }
              })
            }
          />
        )}
      </View>
      <View style={styles.content}>
        {nonProfitOrg.totalSalaries ? (
          <Text>{formatCurrency(nonProfitOrg.totalSalaries)}</Text>
        ) : (
          <Text> {i18n.t('mix.n_a')}</Text>
        )}
      </View>
      <Divider />
    </View>
  );
};

export default TotalSalariesItem;

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  titleContent: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center'
  },

  titleText: {
    fontSize: 22,
    marginRight: 10
  },

  content: {
    marginTop: 10,
    marginBottom: 20
  }
});
